module.exports = __webpack_public_path__ + "img/grin-beam-sweat.c649c4e1.svg";